export { default } from "./HorizontalCalloutCardLink";
